import { getIsMobile } from '@wix/da-shared-react/pkg/publicSession';
import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../selectors/users';
import {
  getInstalledModuleIds,
  getInstallableModuleTypes,
  getIsInstallingModule,
  getCurrentlyInstalledModulePostion,
} from '../../../selectors/layout';
import { getModuleType } from '../../../selectors/modules';

import { moveModule, addModule, removeModule } from '../../../actions/layout';

import { Props } from './Zone';

export type ConnectedKeys =
  | 'installedComponents'
  | 'installedModuleIds'
  | 'installableModuleTypes'
  | 'isCurrentUserProfileOwner'
  | 'isMobile'
  | 'moveModule'
  | 'removeModule'
  | 'addModule';

export type ContainerProps = Without<Props, ConnectedKeys>;

const mapStateToProps = (
  state: AppState,
  props: ContainerProps
): Partial<Props> => {
  const installedModuleIds = getInstalledModuleIds(
    state,
    props.section,
    props.type
  );
  const { mapModuleTypeToWidgetComponent } = props;
  const installedComponents = installedModuleIds
    .map(moduleId => ({
      moduleId,
      ComponentClass:
        mapModuleTypeToWidgetComponent[getModuleType(state, moduleId)],
    }))
    .filter(module => module.ComponentClass);

  const installableModuleTypes = getInstallableModuleTypes(
    state,
    props.section,
    props.type
  );

  return {
    isMobile: getIsMobile(state),
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    isInstallingModule: getIsInstallingModule(state, props.section, props.type),
    currentlyInstalledModulePostion: getCurrentlyInstalledModulePostion(
      state,
      props.section,
      props.type
    ),
    installedComponents,
    installedModuleIds,
    installableModuleTypes,
  };
};

const mapDispatchToProps = (
  dispatch,
  ownProps: ContainerProps
): Partial<Props> => {
  const { section, type: zone } = ownProps;

  return {
    removeModule: moduleId => () =>
      section && dispatch(removeModule({ section, zone, moduleId })),
    addModule: (moduleType, position) =>
      section && dispatch(addModule({ section, zone, moduleType, position })),
    moveModule: (moduleId, position) => () => {
      dispatch(moveModule({ section, zone, moduleId, position }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
